class SaleTypeModel{
    saleTypeId:number;
    name?: string;
    
}
export default SaleTypeModel;